import React from 'react';

import { useIsEditorToolbarDockedAtTop } from '@confluence/content-types-header/entry-points/useIsEditorToolbarDockedAtTop.tsx';

import { EditorConnectionBannerOfflineMode } from './EditorConnectionBannerOfflineMode.tsx';
import type { EditorConnectionBannerWrapperType } from './EditorConnectionBannerTypes.ts';

export const EditorConnectionBannerWrapper = ({
	triggerAnalyticsEvent,
	willEditorDisable,
	contentType,
	contentId,
	spaceId,
	fullPageEditorPresetAPI,
	collabEditState,
	isLivePage,
	isViewMode,
}: EditorConnectionBannerWrapperType): React.JSX.Element => {
	const isEditorToolbarDockedAtTop = useIsEditorToolbarDockedAtTop({
		defaultDockedAtTop: !isLivePage,
	});

	const isEditorToolbarHidden = isViewMode || !isEditorToolbarDockedAtTop;

	return (
		<EditorConnectionBannerOfflineMode
			editorType="next"
			triggerAnalyticsEvent={triggerAnalyticsEvent}
			collabEditState={collabEditState}
			willEditorDisable={willEditorDisable}
			contentType={contentType}
			contentId={contentId}
			spaceId={spaceId}
			fullPageEditorPresetAPI={fullPageEditorPresetAPI}
			isEditorToolbarHidden={isEditorToolbarHidden}
		/>
	);
};
